import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';
import '@fancyapps/ui';
import 'iscroll/build/iscroll';

import './InitGsap';
import 'slick-carousel/slick/slick';
import initLightbox from './initLightbox';

var IScroll = require( 'iscroll' );
require( 'jquery-drawer' );

setTimeout( function() {
	$( '.drawer' ).drawer( {
		iscroll: {
			mouseWheel: true,
			preventDefault: false,
		},
		showOverlay: true,
	} );
}, 100 );

$( '.slider' ).slick( {
	dots: true,
	infinite: true,
	speed: 500,
	fade: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	cssEase: 'linear',
} );

$( '.casestudiesbannerloop' ).slick( {
	dots: true,
	infinite: true,
	arrows: false,
	speed: 300,
	slidesToShow: 5,
	slidesToScroll: 1,
	cssEase: 'linear',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
} );

$( '#mainnavbarNavDropdown' ).prepend( '<button class="offcanvas-close" id="offcanvas-close" aria-label="Close menu">&times;</button>' );

$( '#offcanvas-toggle' ).on( 'click', function() {
	$( '#mainnavbarNavDropdown' ).toggleClass( 'show' );
	$( '#offcanvas-backdrop' ).toggleClass( 'show' );
	$( 'body' ).toggleClass( 'offcanvas-open' );
} );

$( '#offcanvas-close' ).on( 'click', function() {
	$( '#mainnavbarNavDropdown' ).removeClass( 'show' );
	$( '#offcanvas-backdrop' ).removeClass( 'show' );
	$( 'body' ).removeClass( 'offcanvas-open' );
} );

$( '#offcanvas-backdrop' ).on( 'click', function() {
	$( '#mainnavbarNavDropdown' ).removeClass( 'show' );
	$( '#offcanvas-backdrop' ).removeClass( 'show' );
	$( 'body' ).removeClass( 'offcanvas-open' );
} );

$( '.nav-link, .smooth, .nav-link a' ).on( 'click', function() {
	var clickedItem = $( this ).attr( 'href' );

	if ( clickedItem.indexOf( '#' ) > -1 && clickedItem.length > 1 ) {
		$( 'html, body' ).animate(
			{
				scrollTop: $( clickedItem ).offset().top - 100,
			},
			2000
		);
	}
} );

$( '#doc1-tab' ).addClass( 'active' );
$( '#doc1' ).addClass( 'active show' );

$( '.carousel-item-0' ).addClass( 'active' );
$( '.casestudy-0-body' ).addClass( 'show' );

$( '.product_buynow' ).click( function() {
	var productname = $( this ).data( 'product' );
	$( '#drawer_' + productname ).drawer( 'refresh' );
	$( '#drawer_' + productname ).drawer( 'open' );
} );

$( '.productsheet' ).click( function() {
	var productname = $( this ).data( 'product' );
	var input = $( '.gfield.product-title .ginput_container input' );
	input.val( productname );
	var title = $( '#ProductSheetLabel' );
	title.text( productname );
} );

var $eircode = $( '#product-search input#eircode' ),
	$eircodeButton = $( '#product-search button#eircodebutton' ),
	$addressField = $( '#product-search select#address' );

$eircodeButton.on( 'click', gather_addresses );

function gather_addresses( e ) {
	e.preventDefault();

	if ( ! $eircode.val() ) {
		alert( 'Please enter an EIRCode!' );
		return;
	}

	// TEST EIRCODE:
	// D13EA06
	$.post( magnet.ajaxUrl, {
		eircode: $eircode.val(),
		action: 'eircode-lookup',
		_wpnonce: magnet.nonce,
	}, function( response ) {
		if ( response.success ) {
			$addressField.empty().append( $( '<option>', {
				value: '',
				text: 'Please choose an Address!',
			} ) ).change();

			$.each( response.success, function( i, item ) {
				$addressField.append( $( '<option>', {
					value: encodeURI( JSON.stringify( {
						ngaEnabled: item.ngaEnabled,
						fiberType: item.fibreType,
						ardId: item.ardId,
					} ) ),
					text: create_address_line( item ),
				} ) ).change();
			} );
		} else {
			console.log( 'FAILED!' );
		}
	}, 'json' );
}

function create_address_line( values ) {
	var wanted = [
		'unitNumber',
		'unitName',
		'buildingNumber',
		'buildingName',
		'streetNameTown',
		'postalDistName',
		'county',
	];

	var address = '';

	$.each( wanted, function( i, wantedItem ) {
		if ( values[wantedItem] !== null ) {
			address += ' ' + values[wantedItem];
		}
	} );

	return address.trim();
}

//Talk Addons

jQuery( ".talk_addon_1 .gfield_radio input[value='Remove|0']" )
	.parent( 'li' )
	.addClass( 'addon-selected' );
jQuery( ".talk_addon_2 .gfield_radio input[value='Remove|0']" )
	.parent( 'li' )
	.addClass( 'addon-selected' );
jQuery( ".talk_addon_3 .gfield_radio input[value='Remove|0']" )
	.parent( 'li' )
	.addClass( 'addon-selected' );
jQuery( ".talk_addon_4 .gfield_radio input[value='Remove|0']" )
	.parent( 'li' )
	.addClass( 'addon-selected' );

jQuery( ".talk_addon_1 .gfield_radio input[value='Remove|0']" ).click(
	function() {
		jQuery( '.talk_addon_1' ).removeClass( 'addon-selected' );
		jQuery( ".talk_addon_1 .gfield_radio input[value='Remove|0']" )
			.parent( 'li' )
			.addClass( 'addon-selected' );
		jQuery(
			".talk_addon_1 .gfield_radio input[value='Add|0']"
		)
			.parent( 'li' )
			.removeClass( 'addon-selected' );
	}
);
jQuery(
	".talk_addon_1 .gfield_radio input[value='Add|0']"
).click( function() {
	jQuery( '.talk_addon_1' ).addClass( 'addon-selected' );
	jQuery(
		".talk_addon_1 .gfield_radio input[value='Add|0']"
	)
		.parent( 'li' )
		.addClass( 'addon-selected' );
	jQuery( ".talk_addon_1 .gfield_radio input[value='Remove|0']" )
		.parent( 'li' )
		.removeClass( 'addon-selected' );
} );

jQuery( ".talk_addon_2 .gfield_radio input[value='Remove|0']" ).click(
	function() {
		jQuery( '.talk_addon_2' ).removeClass( 'addon-selected' );
		jQuery( ".talk_addon_2 .gfield_radio input[value='Remove|0']" )
			.parent( 'li' )
			.addClass( 'addon-selected' );
		jQuery( ".talk_addon_2 .gfield_radio input[value='Add|0']" )
			.parent( 'li' )
			.removeClass( 'addon-selected' );
	}
);
jQuery( ".talk_addon_2 .gfield_radio input[value='Add|0']" ).click( function() {
	jQuery( '.talk_addon_2' ).addClass( 'addon-selected' );
	jQuery( ".talk_addon_2 .gfield_radio input[value='Add|0']" )
		.parent( 'li' )
		.addClass( 'addon-selected' );
	jQuery( ".talk_addon_2 .gfield_radio input[value='Remove|0']" )
		.parent( 'li' )
		.removeClass( 'addon-selected' );
} );

jQuery( ".talk_addon_3 .gfield_radio input[value='Remove|0']" ).click(
	function() {
		jQuery( '.talk_addon_3' ).removeClass( 'addon-selected' );
		jQuery( ".talk_addon_3 .gfield_radio input[value='Remove|0']" )
			.parent( 'li' )
			.addClass( 'addon-selected' );
		jQuery( ".talk_addon_3 .gfield_radio input[value='Add|6']" )
			.parent( 'li' )
			.removeClass( 'addon-selected' );
	}
);
jQuery( ".talk_addon_3 .gfield_radio input[value='Add|6']" ).click( function() {
	jQuery( '.talk_addon_3' ).addClass( 'addon-selected' );
	jQuery( ".talk_addon_3 .gfield_radio input[value='Add|6']" )
		.parent( 'li' )
		.addClass( 'addon-selected' );
	jQuery( ".talk_addon_3 .gfield_radio input[value='Remove|0']" )
		.parent( 'li' )
		.removeClass( 'addon-selected' );
} );

// Don't allow active accordion to close itself in product buttons
$( '.col-resiprodbtns .btn' ).on( 'click', function( e ) {
	if ( ! $( this ).hasClass( 'collapsed' ) ) {
		e.stopPropagation();
	}
} );

initLightbox();
